module.exports = "/img/cate-off.5129709b.png";